import React from "react";
import "../styles/CodeOfConduct.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Code_Of_Conducts from "../Assets/Pdfs/Code_of_Conducts.pdf";

export default function CodeOfConduct() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="code-conduct-page">
            <section className="code-conduct-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Code of Conducts
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Code_Of_Conducts}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download Button */}
                <p className="pdf-download">
                    <a
                        href={Code_Of_Conducts}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Code of Conducts
                    </a>
                </p>
            </section>

            <footer className="code-conduct-footer">
                <p>We appreciate your commitment to integrity and professionalism.</p>
            </footer>
        </div>
    );
}
